"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconComputerFilled = function IconComputerFilled(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  return _react.default.createElement("svg", {
    id: "icons",
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 50 50"
  }, _react.default.createElement("title", null, "Computer"), _react.default.createElement("path", {
    d: "M43 34V10.5C43 10.3674 42.9473 10.2402 42.8536 10.1464C42.7598 10.0527 42.6326 10 42.5 10H7.5C7.36739 10 7.24021 10.0527 7.14645 10.1464C7.05268 10.2402 7 10.3674 7 10.5V34H4C3.73478 34 3.48043 34.1054 3.29289 34.2929C3.10536 34.4804 3 34.7348 3 35V37C3 38.0609 3.42143 39.0783 4.17157 39.8284C4.92172 40.5786 5.93913 41 7 41H43C44.0609 41 45.0783 40.5786 45.8284 39.8284C46.5786 39.0783 47 38.0609 47 37V35C47 34.7348 46.8946 34.4804 46.7071 34.2929C46.5196 34.1054 46.2652 34 46 34H43ZM29 38H21C20.7348 38 20.4804 37.8946 20.2929 37.7071C20.1054 37.5196 20 37.2652 20 37C20 36.7348 20.1054 36.4804 20.2929 36.2929C20.4804 36.1054 20.7348 36 21 36H29C29.2652 36 29.5196 36.1054 29.7071 36.2929C29.8946 36.4804 30 36.7348 30 37C30 37.2652 29.8946 37.5196 29.7071 37.7071C29.5196 37.8946 29.2652 38 29 38ZM38.5 34H11.5C11.3674 34 11.2402 33.9473 11.1464 33.8536C11.0527 33.7598 11 33.6326 11 33.5V14.5C11 14.3674 11.0527 14.2402 11.1464 14.1464C11.2402 14.0527 11.3674 14 11.5 14H38.5C38.6326 14 38.7598 14.0527 38.8536 14.1464C38.9473 14.2402 39 14.3674 39 14.5V33.5C39 33.6326 38.9473 33.7598 38.8536 33.8536C38.7598 33.9473 38.6326 34 38.5 34Z",
    fill: color
  }));
};

IconComputerFilled.defaultProps = {
  color: 'black',
  size: 30
};
IconComputerFilled.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string
};
var _default = IconComputerFilled;
exports.default = _default;